import { useMsal } from '@azure/msal-react';

import { propagateError } from '../components/ErrorBoundary/propagateError';
import authConfig from '../config/auth';

interface RequestOptions {
  baseUrl?: string;
}

const scopes = [`${authConfig.clientId}/.default`];

export const useRequest = <T>({ baseUrl = process.env.REACT_APP_API_HOST }: RequestOptions = {}) => {
  const { instance } = useMsal();

  return async (path: string, options?: RequestInit): Promise<T> => {
    // MSAL acquireTokenSilent requires an account to be set.
    // After the AAD redirect, the account is available via getActiveAccount()
    // or getAllAccounts()[0]. We pick it at call-time so it's always fresh.
    const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0];
    const request = {
      scopes,
      authority: authConfig.authority,
      account,
    };

    return instance
      .acquireTokenSilent(request)
      .then(async ({ accessToken: token }) =>
        fetch(`${baseUrl}${path}`, {
          ...options,
          headers: {
            Authorization: `Bearer ${token}`,
            ...(options?.headers ?? {}), // eslint-disable-line @typescript-eslint/no-misused-spread
          },
        })
      )
      .then(async (response) => response.json() as Promise<T>)
      .catch((e: unknown) => {
        propagateError(e as Error);
        throw e;
      });
  };
};
